<template>
  <div
    id="devmg"
    v-loading.fullscreen.lock="loading"
    element-loading-text="Waiting...."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
   <span>此版本尚未包含此功能0613</span>



  </div>


</template>

<script>
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
export default {
  data() {
    return {
      loading :false,
      devkindkind:0,
    };
  },
  created(){

  },
  methods: {

    get_file_list() {
      axios
        .get("/Get_file_List_val.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            kind: "mp3"
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatafilelist = res.data.file;
              this.tableDatafilelist.forEach((item, index) => {
                item.filename = Base64.decode(item.filename);
                item.filesize = item.filesize;
              });
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>

<style scoped>
#devmg {
  padding-top: 20px;
  width: 100%;
}
.el-table {
  margin: 20px ;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.edit_dev  {
	text-align:left ;
	/deep/ .el-transfer-panel {
		width:300px;
	}
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/admin_jifei.vue